/// <reference types="react" />
/// <reference types="react-dom" />
export type ToggleProps = {
	checked: boolean
	onChange: (checked: boolean) => void
	label?: string
	className?: string
}

export const Toggle = ({ checked, onChange, label, className = '' }: ToggleProps) => (
	<label className={`inline-flex items-center gap-2 cursor-pointer ${className}`}>
		<input
			type='checkbox'
			checked={checked}
			onChange={(e) => onChange(e.target.checked)}
			className='hidden'
		/>
		<span className={`w-9 h-5 rounded-full border relative border-neutral-300 dark:border-neutral-700 ${checked ? 'bg-emerald-500' : 'bg-neutral-500'}`}>
			<span className={`absolute top-0.5 left-0.5 w-4 h-4 rounded-full bg-white transition-all ${checked ? 'translate-x-4' : ''}`}></span>
		</span>
		{label && <span className='text-xs opacity-80'>{label}</span>}
	</label>
)
